import React, { createContext, useContext, useState, useCallback } from 'react';

const AuthContext = createContext(null);

const MOCK_USERS = {
  coach: {
    id: 'coach-001',
    name: 'Alex Rivera',
    email: 'alex@fitndex.com',
    role: 'coach',
    avatar: null,
    phoneNumber: null,
    homeGym: null,
    workoutTime: null,
    lastActive: new Date().toISOString(),
    team: ['athlete-001', 'athlete-002', 'athlete-003'],
  },
  athlete: {
    id: 'athlete-001',
    name: 'Jordan Lee',
    email: 'jordan@fitndex.com',
    role: 'athlete',
    avatar: null,
    phoneNumber: null,
    homeGym: null,
    workoutTime: null,
    lastActive: new Date().toISOString(),
    coachId: 'coach-001',
  },
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem('fitndex_user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const login = useCallback((email, password, role) => {
    const mockUser = role === 'coach' ? MOCK_USERS.coach : MOCK_USERS.athlete;
    const authedUser = { ...mockUser, email };
    setUser(authedUser);
    localStorage.setItem('fitndex_user', JSON.stringify(authedUser));
    return { success: true, user: authedUser };
  }, []);

  const register = useCallback((name, email, password, role) => {
    const base = role === 'coach' ? MOCK_USERS.coach : MOCK_USERS.athlete;
    const newUser = { ...base, name, email, id: `${role}-${Date.now()}` };
    setUser(newUser);
    localStorage.setItem('fitndex_user', JSON.stringify(newUser));
    return { success: true, user: newUser };
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    localStorage.removeItem('fitndex_user');
  }, []);

  const updateUser = useCallback((fields) => {
    setUser((prev) => {
      if (!prev) return prev;
      const updated = { ...prev, ...fields };
      localStorage.setItem('fitndex_user', JSON.stringify(updated));
      return updated;
    });
  }, []);

  const value = {
    user,
    role: user?.role ?? null,
    isAuthenticated: !!user,
    isCoach: user?.role === 'coach',
    isAthlete: user?.role === 'athlete',
    login,
    register,
    logout,
    updateUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
